<template>
	<div id="buildingEnterForm" class="formPage">
		<formheader :title="title"></formheader>
        <div class="imgBox">
            <img src="../../images/newImages/bg_shengjizongheti.png" alt="">
            <div class="floatBox">
                <div class="title">省级综合体入驻</div>
                <div class="subtitle">享受配套政策、金融扶持、产业资源的全方位扶持</div>
            </div>
            <div class="rightBtn" @click="toEnter">
                <button class="btn-white">了解更多</button>
            </div>
        </div>
		<div class="mainContent">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm formWrap">
				<el-form-item label="姓名" prop="appRealname">
					<el-input v-model="ruleForm.appRealname" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="appCellphone">
					<el-input type="text" v-model="ruleForm.appCellphone" placeholder="请输入手机号" @change="filterPhone"></el-input>
				</el-form-item>
				<el-form-item label="公司名称" prop="appCompanyName">
					<el-input v-model="ruleForm.appCompanyName" placeholder="请输入公司名称"></el-input>
				</el-form-item>
				<el-form-item label="面积" prop="mj_content" label-width="92px">
					<el-input type="textarea" v-model="ruleForm.mj_content" placeholder="如：200平方米"  rows=3 style="padding-top:10px;"></el-input>
				</el-form-item>
				<el-form-item label="区域" prop="qy_content" label-width="92px">
					<el-input type="textarea" v-model="ruleForm.qy_content" placeholder="如：综合体总部或临平附近"  rows=3 style="padding-top:10px;"></el-input>
				</el-form-item>
				<el-form-item label="空间类型" prop="kjlx_content" label-width="92px">
					<el-input type="textarea" v-model="ruleForm.kjlx_content" placeholder="如：厂房/设计师工作室/展厅/面辅料中心"  rows=3 style="padding-top:10px;"></el-input>
				</el-form-item>
				<el-form-item label="主要业务" prop="zyyw_content" label-width="92px" >
					<el-input type="textarea" v-model="ruleForm.zyyw_content" placeholder="如：设计、打板、电商、生产、软件"  rows=3 style="padding-top:10px;"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="bz_content" label-width="92px">
					<el-input type="textarea" v-model="ruleForm.bz_content" placeholder="在此输入备注" rows=3  style="padding-top:10px;"></el-input>
				</el-form-item>

				<!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->

			</el-form>
		<!-- 	<div class="center small red">
				<a href="tel:0571-86221010">客服电话：0571-86221010</a>
			</div>
			<div class="longBtnBox">
				<button type="primary" @click="submitForm('ruleForm')" class="btn-long btn-red">提交</button>
			</div> -->
            <div class="btnBox">
                <button id="submitBtn" class="btn-long btn-red" @click="submitForm('ruleForm')">提交</button>
                <a href="tel:0571-86221010">
                    <button  class="btn-long btn-red reverse">
                        <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon"> 0571-86221010 
                    </button>
                </a>
                
            
            </div>
		</div>

	</div>
</template>

<script>
	import formheader from '@/page/formPage/formHeader';
	import axios from 'axios';
	import { ajaxform, ajaxToken } from '@/assets/request.js'
	import { formRule,filterPhoneNum } from '@/assets/common.js'
	export default {
		data() {
			
			return {
				title: "省级综合体入驻表单",
				ruleForm: {
					appRealname: '',
					appCellphone: '',
					appCompanyName: '',
				},
				rules: formRule()

			}
		}, //data end
		components: {
			formheader
		},
		methods: {
            toEnter() {
                this.$router.push({
                    name: 'BuildingEnter'
                });
            
            },
				filterPhone(){
				this.ruleForm.appCellphone=filterPhoneNum(this.ruleForm.appCellphone)
			},
			submitForm(formName) {
				let _this = this
				let type = 1 //1为综合体线下实体空间入驻申请，2为相关政策了解申请，3为金融服务申请，4为产业配套服务申请，5为产业互联网服务申请，6为工厂培训申请
				this.$refs[formName].validate((valid) => {
					if(valid) {
						ajaxform(type, "/infoplatform/fashionapplication/applicationMessageEntry", _this.ruleForm).then((res) => {
							console.log("成功res")
							console.log(res)
						}, (res) => {
							console.log("失败res")
							console.log(res)
						})
						//						
					} else {
                        _this.$message({
                        	message:"表单填写不正确",
                        	duration: 1000,
                        });
						console.log('error submit!!');
						return false;
					}
				});
			},
		},
		mounted() {

		}
	}
</script>

<style lang="less">
	// *{outline:1px solid blue;}
	.formPage{
	    background: #fff;
	    .btnBox{
	        padding:0.6rem 0.32rem;
	        button.btn-long{font-size: 0.36rem ;margin-bottom: 0.4rem;}
	        .btnIcon{
	            width: 0.48rem;height: 0.48rem; vertical-align: bottom;
	        }
	    }
        
        .imgBox{
            position: relative;
            img{width: 100%}
            .floatBox{
                color:#fff; 
                position: absolute; top:0; padding:0 0.4rem;
                .title{
                   font-size: 0.48rem; font-weight: bold; line-height: 0.67rem; padding-top:0.68rem;
                }
                .subtitle{font-size: 0.28rem;line-height: 0.38rem;width: 3.69rem;margin-top:0.14rem;letter-spacing: 0.5px;}
                
            }
            .rightBtn{position: absolute;right:0.4rem;bottom:0.6rem; font-size: 0.2rem;
                button{padding:0.11rem 0.17rem;}
            }
        }
	}
	.el-form-item{
	    // outline:1px solid blue;
	    background: #fff; padding:0 0.32rem; 
	    border-bottom: 1px solid #eee;
	}
	/*表单label比较长的部分样式*/
	
	.formWrap .blockLabel {
		.el-form-item__label {
			display: block;
			width: 100% !important;
			text-align: left !important;
			text-align-last: auto !important;
	        
		}
		.el-radio__label {
			font-size: 0.29rem; color:#111A34; font-weight: bold;
		}
		.el-form-item__content {
			margin-left: 0.1rem !important;
			;
		}
		.el-radio {
			display: block !important;
			line-height: 5;
	        border-bottom: 1px solid #eee; 
		}
		.el-radio+.el-radio {
			margin-left: 0 !important;
		}
	}
	
	.formWrap {
	    background: #fff; padding-top:0.22rem;
		// padding: 0.8rem 0.7rem 0.2rem;
		/*输入框*/
		.el-input__inner {
			// height: 0.75rem;
			// line-height: 0.75rem;
	        border:none;
	        padding-bottom: 0.22rem;
	        padding-left:0;
		}
		.el-textarea__inner {
			padding: 0px 10px;
		}
		/*标签*/
		.el-form-item__label {
			// font-weight: bold;
			text-align: left;
			// text-align-last: justify;
			/*padding-left:0.7rem;*/
		}
		.el-form-item {
			margin-bottom: 0.2rem;
		}
		.el-form-item__error {
			padding-top: 0;
		}
		.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
			margin-right: 0;
		}
	    textarea{border:0;}
	}
</style>


// WEBPACK FOOTER //
// src/page/formPage/buildingEnterForm.vue